import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
var Portal = function Portal(props) {
  var children = props.children,
    _props$container = props.container,
    container = _props$container === void 0 ? document.body : _props$container;
  var el = useRef(document.createElement('div'));
  useEffect(function () {
    if (!container) {
      return;
    }
    container.appendChild(el.current);
    return function () {
      container.removeChild(el.current);
    };
  }, [container]);
  return /*#__PURE__*/ReactDOM.createPortal(children, el.current);
};
export default Portal;